import { PayloadAction } from '@reduxjs/toolkit';
import { call, put } from 'redux-saga/effects';

import { rikHttpClient } from 'services/httpClient';
import IMarkThreadMessageAsOpenRequestBody from 'services/httpClient/requests/intervention/IMarkThreadMessageAsOpenRequestBody';

import { interventionActions } from '../index';
import { IMarkThreadMessageAsOpenRequestAction } from '../reducers/markThreadMessageAsOpen/request';

function* markThreadMessageAsOpen(
  action: PayloadAction<IMarkThreadMessageAsOpenRequestAction>,
) {
  try {
    const body: IMarkThreadMessageAsOpenRequestBody = {
      ids: action.payload.data.messageIds,
      open: true,
    };

    yield call(
      rikHttpClient.put,
      `messages/${action.payload.data.threadMessageId}/mark_messages_as_open`,
      body,
    );

    yield put(interventionActions.markThreadMessageAsOpenSuccess());
  } catch (err: any) {
    action.payload.functions.error(err);

    yield put(interventionActions.markThreadMessageAsOpenFailure());
  }
}

export default markThreadMessageAsOpen;
